import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private apiUrl =  `${environment.apiUrl}/api/municipios`; 
  //private apiUrl = 'http://localhost:3000/api/municipios';

  constructor(private http: HttpClient) {}

  getDatos(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      catchError(error => {
        console.error('Error al obtener datos:', error);
        return throwError(() => error);
      })
    );
  }

  inactivarMunicipio(IDMUN: string): Observable<any> {
    const url = `${this.apiUrl}/inactivar/${IDMUN}`;
    return this.http.put(url, {}).pipe(
      catchError(error => {
        console.error('Error al inactivar municipio:', error);
        return throwError(() => error);
      })
    );
  }

  getDatosInactivos(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/inactivos`).pipe(
      catchError(error => {
        console.error('Error al obtener datos inactivos:', error);
        return throwError(() => error);
      })
    );
  }

  activarMunicipio(MUNICIPIO: string): Observable<any> {
    const url = `${this.apiUrl}/activar/${MUNICIPIO}`;
    return this.http.put(url, {}).pipe(
      catchError(error => {
        console.error('Error al activar municipio:', error);
        return throwError(() => error);
      })
    );
  }

  editarMunicipio(id: string, data: any): Observable<any> {
    const url = `${this.apiUrl}/${id}`;
    return this.http.put(url, data).pipe(
      catchError(error => {
        console.error('Error al editar municipio:', error);
        return throwError(() => error);
      })
    );
  }

  crearMunicipio(data: any): Observable<any> {
    return this.http.post(this.apiUrl, data).pipe(
      catchError(error => {
        console.error('Error al crear municipio:', error);
        return throwError(() => error);
      })
    );
  }

  getMunicipioPorIDMUN(IDMUN: string): Observable<any> {
    const url = `${this.apiUrl}/${IDMUN}`;
    return this.http.get<any>(url).pipe(
      catchError(error => {
        console.error('Error al obtener municipio por IDMUN:', error);
        return throwError(() => error);
      })
    );
  }

  // Método sin implementación
  getRazas() {
    throw new Error('Method not implemented.');
  }
}
